import { withSearch } from '@elastic/react-search-ui';
import DateRangeFilters from '../../../components/filter/DateRangeFilter';

function ArchiveYearRangeFilter({ setFilter, removeFilter, filters }) {
  return (
    <DateRangeFilters
      filters={filters}
      formHint="Please enter a day, month and year, for example, 01 05 2023"
      fromFieldId="dateFrom"
      id="date-range"
      label="Find items from a specific year or time period"
      removeFilter={removeFilter}
      setFilter={setFilter}
      toFieldId="dateTo"
    />
  );
}

export default withSearch(({ removeFilter, setFilter, filters }) => ({
  setFilter,
  removeFilter,
  filters,
}))(ArchiveYearRangeFilter);
